export default "__VITE_ASSET__DkmZ0PPc__"